import { useCampaignHeaders } from '@/components/Functional/hooks-core/useCampaignHeaders'
import { createApi } from '@/components/Functional/lib/createApi'
import type { BoundApi } from '@/components/Functional/lib/createApi'
import { useRef } from 'react'

/**
 * ヘッダー付き API バインドを返すフック。
 *
 * - 通常の React コンポーネント・フックでは戻り値をそのまま使用する。
 * - XState actor など React ライフサイクル外で最新ヘッダーを参照したい場合は
 *   `useApiRef()` を使って `ref.current` 経由でアクセスする。
 */
export const useApi = (): BoundApi => {
  const { headers, headersWithAuthorization } = useCampaignHeaders()
  return createApi({ headers, headersWithAuthorization })
}

/**
 * XState actor 向けのユーティリティ。毎レンダーで ref.current を更新し
 * 古いトークンを握り続けないようにする。
 */
export const useApiRef = () => {
  const { headers, headersWithAuthorization } = useCampaignHeaders()
  const boundApi = createApi({ headers, headersWithAuthorization })
  const boundApiRef = useRef<BoundApi>(boundApi)
  // 毎レンダーで最新の bound API で上書き（古いトークンを掴まないように）
  boundApiRef.current = boundApi
  return boundApiRef
}
